export default __webpack_public_path__ + "static/media/Megosu-Animation-Made.com.589fa55c.mp4";